import { HashRouter, Routes, Route } from 'react-router'
import HomePage from './pages/HomePage'
import AssessmentPage from './pages/AssessmentPage'
import RelaxPage from './pages/RelaxPage'
import ScrollToTop from './components/ScrollToTop'

export default function App() {
  return (
    <HashRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/assessment" element={<AssessmentPage />} />
        <Route path="/relax" element={<RelaxPage />} />
      </Routes>
    </HashRouter>
  )
}
